import React, {useEffect} from "react";
import styled from 'styled-components';
import {useDropzone} from "react-dropzone";


const FileDragAndDropContainer = styled.div`
  position: relative;
  margin-top: 40px;
  width: 100%;
  height: ${p => p.isDragActive ? (p.textAreaNumberOfLines && p.textAreaNumberOfLines > 5 ? "102px" : `${p.textAreaNumberOfLines * 24 + 16}px`) : ''};
  bottom: ${p => p.isDragActive ? "7px" : ''};
  div.dropzone-blur-effect {
    width: 100%;
    height: ${p => p. textAreaNumberOfLines && p .textAreaNumberOfLines > 5 ? "120px": `${p.textAreaNumberOfLines * 20 + 20}px`};
    display: ${(p) => (p.isDragActive ? "flex" : "none")};
    justify-content: center;
    align-items: center;
    position: absolute;
    border: 1.4px dashed #ffffff;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 3px 10px rgba(66, 82, 110, 0.2);
    backdrop-filter: blur(6px);
    z-index: 1;
    bottom: -3px;
  }
`;

const DragAndDrop = props => {
    const {onDrop, children, textAreaNumberOfLines, setHeight} = props;

     // let isDragActive= true;
    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone(
        {
            onDrop,
            noClick: true,
            noKeyboard: true,
        });

    useEffect(()=>{
        setHeight();
    }, [isDragActive])

    return (
        <FileDragAndDropContainer
            textAreaNumberOfLines={textAreaNumberOfLines}
            {...getRootProps({
                refKey: "innerRef",
                isDragActive,
            })}
        >
            <input {...getInputProps()} />
            <div className="dropzone-blur-effect">
                Drop your files here!
            </div>
            <div>{!isDragActive && children}</div>
        </FileDragAndDropContainer>
    )

}

export default DragAndDrop;